import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  count: 0,        // عدد التنبيهات غير المقروءة
  list: [],         // قائمة التنبيهات نفسها لو حبيت تخزنها
  isLoaded: false   // مؤشر هل حملنا التنبيهات من السيرفر ولا لسه
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    // 🎯 الأمر اللي إنت سألت عليه: بيزود العداد 1
    incrementNotificationCount: (state) => {
      state.count += 1;
    },
    
    // أمر تصفير العداد (لما اليوزر يفتح صندوق الوارد)
    resetNotificationCount: (state) => {
      state.count = 0;
    },
    
    // أمر تحديث القائمة بالكامل (مثلاً بعد Fetch من الـ API)
    setNotifications: (state, action) => {
      state.list = action.payload;
      state.count = action.payload.filter(n => !n.is_read).length;
      state.isLoaded = true;
    }
  }
});

// بنصدر الأوامر (Actions) عشان نستخدمها بالـ useDispatch
export const { 
  incrementNotificationCount, 
  resetNotificationCount, 
  setNotifications 
} = notificationsSlice.actions;

// بنصدر الـ reducer عشان نضيفه في الـ Store الكبير
export default notificationsSlice.reducer;